export function getPlaceholderAvatarSrc({ walletAddress }: { walletAddress: string }) {
  // take a slice of the address
  const hexString = walletAddress ? walletAddress.slice(walletAddress.length - 8) : '0';

  // convert to decimal and get variant index
  const variantIndex = walletAddress ? parseInt(hexString, 16) : 0;

  // use the number to select a random placeholder
  const variant = (variantIndex % 8) + 1;

  return `https://d16zqvkniqf1rn.cloudfront.net/placeholders/avatars/v2/${variant}.jpg`;
}
